import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence } from '@eas/common-web';
import { createDeadlineRowStyle } from '@composite/deadlines/deadline-field';
import { useAuthoredEvidence } from '@composite/evidence/authored-evidence';
import { useDictionaryHookedSources } from '@components/evidence/dictionary-evidence/dictionary-hooked-sources';
import { Deadline } from '@models';
import { EntityName, EvidenceApiUrl, HistoryEntityType } from '@enums';
import { useColumns } from './deadline-columns';
import { Fields } from './deadline-fields';
import { useValidationSchema } from './deadline-schema';

export const DEADLINES_IDENTIFIER = 'DEADLINES';
export const DEADLINES_VERSION = 6;

export function Deadlines() {
  const validationSchema = useValidationSchema();
  const intl = useIntl();
  const columns = useColumns();

  const evidence = useAuthoredEvidence<Deadline>({
    version: DEADLINES_VERSION,
    identifier: DEADLINES_IDENTIFIER,
    apiProps: {
      url: EvidenceApiUrl.DEADLINES,
      hookedSources: useDictionaryHookedSources({
        entityType: HistoryEntityType.DEADLINE,
      }),
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ES__DICT_DEADLINES__TABLE__TITLE',
        defaultMessage: 'Lhůty',
      }),
      defaultSorts: [
        {
          field: 'startingFrom',
          datakey: 'startingFrom',
          order: 'ASC',
          type: 'FIELD',
        },
      ],
      showBulkActionButton: false,
      showNamedSettingsButton: false,
      createRowStyle: createDeadlineRowStyle,
    },
    detailProps: {
      entityName: EntityName.DEADLINE,
      validationSchema,
      GeneralFieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__DEADLINES__DETAIL__TITLE',
          defaultMessage: 'Lhůta',
        }),
        showBtn: (button) => {
          return button === 'REFRESH' || button === 'SHARE';
        },
      },
    },
  });

  return <Evidence {...evidence} />;
}
